import { apiClient, requiresAuth } from '../client';
import { User } from '../../types';

export const usersService = {
  getAllUsers: async () => {
    console.log('[API] usersService.getAllUsers - Fetching all users - START');
    try {
      return requiresAuth(async () => {
        const response = await apiClient.get('/users');
        console.log(
          '[API] usersService.getAllUsers - Response data type:',
          typeof response.data
        );
        console.log(
          '[API] usersService.getAllUsers - Is response.data an array?',
          Array.isArray(response.data)
        );
        if (!Array.isArray(response.data)) {
          console.log(
            '[API] usersService.getAllUsers - Response data structure:',
            response.data
          );
        }
        return response.data.users || response.data;
      });
    } catch (error) {
      console.error(
        '[API] usersService.getAllUsers - Error fetching users:',
        error
      );
      throw error;
    }
  },

  createUser: async (userData: Partial<User> & {
    password: string;
    password_confirmed?: string;
  }) => {
    console.log('[API] usersService.createUser - Creating user:', userData);
    try {
      return requiresAuth(async () => {
        const response = await apiClient.post('/signup', userData);
        return response.data;
      });
    } catch (error) {
      console.error('[API] usersService.createUser - Error creating user:', error);
      throw error;
    }
  },

  getSelfUser: async () => {
    return requiresAuth(async () => {
      const response = await apiClient.get('/users/self');
      return response.data;
    });
  },

  getUserById: async (userId: string) => {
    return requiresAuth(async () => {
      const response = await apiClient.get(`/users/${userId}`);
      return response.data;
    });
  },

  updateUser: async (userId: string, userData: Partial<User>) => {
    console.log('[API] usersService.updateUser - Updating user:', userId, userData);
    try {
      return requiresAuth(async () => {
        const response = await apiClient.put(`/users/${userId}`, userData);
        return response.data;
      });
    } catch (error) {
      console.error('[API] usersService.updateUser - Error updating user:', error);
      throw error;
    }
  },

  deleteUser: async (userId: string) => {
    return requiresAuth(async () => {
      const response = await apiClient.delete(`/users/${userId}`);
      return response.data;
    });
  },

  adminSetPassword: async (
    userId: string,
    password: string,
    password_confirmed: string
  ) => {
    return requiresAuth(async () => {
      const response = await apiClient.post(
        `/users/${userId}/admin-set-password`,
        { password, password_confirmed }
      );
      return response.data;
    });
  },
};
